import { IdentityDocument } from '@app/entities/models/personal-data/identity-document.model';

export class PersonalDataProfile {
  name!: string;
  firstSurname!: string;
  secondSurname!: string;
  identificationDocument!: string;
  identificationDocuments: IdentityDocument[] = [];
  civilStatusId!: string;
  civilStatusName!: string;
  fiscalAlert!: boolean;
}
